import { motion } from 'framer-motion';
import React from 'react';
import { TRANSITION_SETTING } from 'Shared/utils';

export const StaggeredAnimationContainer: React.FC<{
  className?: string;
  children?: React.ReactNode;
}> = ({ children, ...props }) => (
  <motion.div
    {...props}
    initial="initial"
    animate="enter"
    exit="exit"
    variants={{
      enter: {
        opacity: 1,
        transition: {
          when: 'beforeChildren',
          staggerChildren: 0.1,
        },
      },
      exit: {
        opacity: 0,
        transition: {
          when: 'afterChildren',
          staggerChildren: 0.1,
        },
      },
    }}
  >
    {children}
  </motion.div>
);

export const StaggeredAnimatedComponent: React.FC<{
  className?: string;
  children?: React.ReactNode;
}> = ({ className, children }) => (
  <motion.div
    className={className}
    variants={{
      initial: { scale: 0.9, opacity: 0 },
      enter: { scale: 1, opacity: 1, transition: TRANSITION_SETTING },
      exit: {
        y: '10%',
        opacity: 0,
        transition: TRANSITION_SETTING,
      },
    }}
  >
    {children}
  </motion.div>
);
